module.exports = "/images/product-service-sales-funnels.svg?480479864f61b10db09b29ad06a6052c";